import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ProfileMe } from '@shared/interfaces/profile-me.interface';
import { ApiResponse } from '@shared/interfaces/wrap-api-response.interface';
import { from, Observable, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { encryptPasswordWithTimestamp } from '@shared/utils/crypto.utils';

@Injectable({
	providedIn: 'root'
})
export class UsersService {
	private http = inject(HttpClient);
	private url = environment.API_DOMAIN + environment.SERVICES.ADMIN;

	constructor() {}

	public getUserInfo(): Observable<ApiResponse<ProfileMe>> {
		return this.http.get<ApiResponse<ProfileMe>>(`${this.url}user/profile/me`);
	}

	/**
	 * Cambia la contraseña del usuario actual
	 * - oldPassword: doble hash con timestamp (SHA256(SHA256(password) + timestamp))
	 * - newPassword: hash simple sin timestamp (SHA256(password))
	 *
	 * @param oldPassword Contraseña actual en texto plano
	 * @param newPassword Nueva contraseña en texto plano
	 * @returns Observable con la respuesta del servidor
	 */
	public changePassword(oldPassword: string, newPassword: string): Observable<ApiResponse<unknown>> {
		const timestamp = Date.now();

		// oldPassword: con timestamp (doble hash)
		// newPassword: sin timestamp (hash simple)
		return from(
			Promise.all([
				encryptPasswordWithTimestamp(oldPassword, timestamp), // CON timestamp
				encryptPasswordWithTimestamp(newPassword) // SIN timestamp
			])
		).pipe(
			switchMap(([oldPasswordEncrypted, newPasswordEncrypted]) => {
				const body = {
					oldPassword: oldPasswordEncrypted,
					newPassword: newPasswordEncrypted,
					timestamp
				};
				return this.http.post<ApiResponse<unknown>>(`${this.url}user/change-password`, body);
			})
		);
	}
}
